import type { IShopSelectShop, IDisplayShop } from "../types";
import {
  ShopSelectShopType,
  ShopSelectDisplayField,
  ShopSelectShopTypeNumeric,
} from "../enums";
import {
  SHOPS_NAMES_MAP,
  SHOPS_LIST_ITEM_HEIGHT,
  LABEL_SHOP_UNKNOWN,
  LABEL_SHOP_REGULAR,
  LABEL_SHOP_COSMETIC,
  LABEL_SHOP_APTEKA,
  LABEL_SHOP_FAMILY,
  LABEL_SHOP_EXTRA,
  LABEL_SHOP_MASTER,
  LABEL_SHOP_WHOLESALE,
  LABEL_SHOP_V1,
} from "../constants";

export const getScheduleString = (shop: {
  closingHours?: string;
  openingHours?: string;
}) => {
  const { openingHours, closingHours } = shop;
  if (!openingHours || !closingHours) return "";
  return `${openingHours} - ${closingHours}`;
};

export const getDisplayConfiguration = (
  shops: IShopSelectShop[],
  selectedShop: IShopSelectShop | null,
) => {
  const list: IDisplayShop[] = [];
  const typesArr: ShopSelectShopType[] = [];
  const selectedShopCode = selectedShop?.code;
  const convert = (shop: IShopSelectShop, selected = false) => {
    const {
      code,
      storeType,
      address,
      openingHours,
      closingHours,
      latitude,
      longitude,
    } = shop;
    return {
      title: "",
      code,
      storeType,
      address,
      latitude,
      longitude,
      approxHeight: SHOPS_LIST_ITEM_HEIGHT,
      selected,
      openingHours,
      closingHours,
      label: SHOPS_NAMES_MAP[storeType] ?? LABEL_SHOP_UNKNOWN,
    };
  };
  if (selectedShopCode) {
    const selectedShopInArr = shops.find((s) => s.code === selectedShopCode);
    if (selectedShopInArr) {
      list.push(convert(selectedShop, true));
    }
  }
  for (let i = 0, len = shops.length; i < len; i += 1) {
    const single = shops[i];
    const { code, storeType } = single;
    if (!typesArr.includes(storeType)) typesArr.push(storeType);
    if (code === selectedShopCode) continue;
    list.push(convert(single));
  }
  const shopListDisplayFields =
    typesArr.length > 1
      ? [ShopSelectDisplayField.StoreType, ShopSelectDisplayField.Address]
      : [ShopSelectDisplayField.Address, ShopSelectDisplayField.Schedule];
  return {
    list,
    typesArr,
    shopListDisplayFields,
  };
};

export const convertShopTypeToNumeric = (
  t: ShopSelectShopType,
): ShopSelectShopTypeNumeric | undefined => {
  switch (t) {
    case ShopSelectShopType.AtHouse:
      return ShopSelectShopTypeNumeric.AtHouse;
    case ShopSelectShopType.Cosmetic:
      return ShopSelectShopTypeNumeric.Cosmetic;
    case ShopSelectShopType.Pharmacy:
      return ShopSelectShopTypeNumeric.Pharmacy;
    case ShopSelectShopType.Extra:
      return ShopSelectShopTypeNumeric.Extra;
    case ShopSelectShopType.Master:
      return ShopSelectShopTypeNumeric.Master;
    case ShopSelectShopType.Family:
      return ShopSelectShopTypeNumeric.Family;
    case ShopSelectShopType.Wholesale:
      return ShopSelectShopTypeNumeric.Wholesale;
    case ShopSelectShopType.V1:
      return ShopSelectShopTypeNumeric.V1;
    default:
      return undefined;
  }
};

export const convertShopTypeToStringId = (
  t: ShopSelectShopTypeNumeric,
): ShopSelectShopType | undefined => {
  switch (t) {
    case ShopSelectShopTypeNumeric.AtHouse:
      return ShopSelectShopType.AtHouse;
    case ShopSelectShopTypeNumeric.Cosmetic:
      return ShopSelectShopType.Cosmetic;
    case ShopSelectShopTypeNumeric.Pharmacy:
      return ShopSelectShopType.Pharmacy;
    case ShopSelectShopTypeNumeric.Extra:
      return ShopSelectShopType.Extra;
    case ShopSelectShopTypeNumeric.Master:
      return ShopSelectShopType.Master;
    case ShopSelectShopTypeNumeric.Family:
      return ShopSelectShopType.Family;
    case ShopSelectShopTypeNumeric.Wholesale:
      return ShopSelectShopType.Wholesale;
    case ShopSelectShopTypeNumeric.V1:
      return ShopSelectShopType.V1;
    default:
      return undefined;
  }
};

export const getShopTitleByEnum = (
  t: ShopSelectShopTypeNumeric | ShopSelectShopType,
) => {
  switch (t) {
    case ShopSelectShopType.AtHouse:
    case ShopSelectShopTypeNumeric.AtHouse:
      return LABEL_SHOP_REGULAR;
    case ShopSelectShopType.Cosmetic:
    case ShopSelectShopTypeNumeric.Cosmetic:
      return LABEL_SHOP_COSMETIC;
    case ShopSelectShopType.Pharmacy:
    case ShopSelectShopTypeNumeric.Pharmacy:
      return LABEL_SHOP_APTEKA;
    case ShopSelectShopType.Family:
    case ShopSelectShopTypeNumeric.Family:
      return LABEL_SHOP_FAMILY;
    case ShopSelectShopType.Extra:
    case ShopSelectShopTypeNumeric.Extra:
      return LABEL_SHOP_EXTRA;
    case ShopSelectShopType.Master:
    case ShopSelectShopTypeNumeric.Master:
      return LABEL_SHOP_MASTER;
    case ShopSelectShopType.Wholesale:
    case ShopSelectShopTypeNumeric.Wholesale:
      return LABEL_SHOP_WHOLESALE;
    case ShopSelectShopType.V1:
    case ShopSelectShopTypeNumeric.V1:
      return LABEL_SHOP_V1;
    default:
      return "";
  }
};
